import React from 'react';
import PropTypes from 'prop-types';

import MuiLink from '@material-ui/core/Link';

import { useLinkStyles } from './styles';
import { Tooltip } from '@material-ui/core';

const Link = ({ children, ...rest }) => {
	const linkClasses = useLinkStyles(rest);

	return (
		<Tooltip title={rest.tooltipTitle} disableHoverListener={!rest.tooltipTitle}>
			<MuiLink
				variant={rest.variant || 'body1'}
				rel={rest.target === '_blank' ? 'noopener' : ''}
				{...rest}
				classes={linkClasses}>
				{children}
			</MuiLink>
		</Tooltip>
	);
};

Link.propTypes = {
	children: PropTypes.node.isRequired
};

export default Link;
